module.exports = __webpack_public_path__ + "static/media/Billion-Calligraphy-Regular.6d8b6d1e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Billion-Calligraphy-Regular.ttf
// module id = 2302
// module chunks = 50